/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Integrate_Models_CtaInputs */

const en_directory_integrate_models_cta = /** @type {(inputs: Directory_Integrate_Models_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open model comparison`)
};

const zh_directory_integrate_models_cta = /** @type {(inputs: Directory_Integrate_Models_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开模型对比`)
};

/**
* | output |
* | --- |
* | "Open model comparison" |
*
* @param {Directory_Integrate_Models_CtaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_integrate_models_cta = /** @type {((inputs?: Directory_Integrate_Models_CtaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Integrate_Models_CtaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_integrate_models_cta(inputs)
	return zh_directory_integrate_models_cta(inputs)
});
export { directory_integrate_models_cta as "directory.integrate.models.cta" }